import React, { useState } from 'react';

import WalletTransactionModal from 'Components/WalletPayment/WalletTransactionModal';
import Modal from 'Components/Globals/Elements/Modal/loadable';
import Icon from 'Components/Globals/Elements/Icon/loadable';
import useContent from 'Hooks/useContent';
import {
	convertGregorianToJalali,
	convertRialToToman,
	composeClassNames,
} from 'Helpers';

import styles from './styles.module.scss';
import strings from './strings';

const WalletTransactionCard = ({ walletTransactionList }) => {
	const { formatMessage } = useContent();

	const [showModal, setShowModal] = useState(false);
	const [selectedCard, setSelectedCard] = useState(null);

	const handleShowModal = (card) => {
		setSelectedCard(card);
		setShowModal(true);
	};
	const handleCloseModal = () => {
		setSelectedCard(null);
		setShowModal(false);
	};
	return (
		<>
			{walletTransactionList.map((card, i) => {
				return (
					<div
						className='bg-white mh-16 ph-16 pv-16 mt-8'
						key={i}
					>
						<div className={styles.wrapper}>
							<p
								className={composeClassNames([
									'bold xs txt-dark',
									styles.wrapper,
								])}
							>
								{card?.attributes?.amount &&
									convertRialToToman(
										card?.attributes?.amount - (card?.attributes?.discount ?? 0)
									).replaceAll(',', '،')}
								<Icon
									name='toman'
									className='txt-dark'
									size='md'
								/>
								{card?.attributes?.settlement?.status === 'done' && (
									<span className={styles.wrapper__badge}>تسویه شده</span>
								)}
							</p>

							<div
								className={styles.wrapper}
								onClick={() => handleShowModal(card)}
							>
								<p className='bold xs txt-primary'>
									{formatMessage(strings.detail)}
								</p>
								<Icon
									name='arrow-withouttale-left-stroke'
									className='bold txt-primary'
									size='md'
								/>
							</div>
						</div>

						<p
							className={composeClassNames(['mt-16 txt-dark xs', styles.date])}
						>
							{convertGregorianToJalali(card?.attributes?.confirmed_at, true)}
						</p>
						<div className={styles.border}></div>
					</div>
				);
			})}
			<Modal
				bottomSheet
				onClose={() => handleCloseModal()}
				show={showModal}
				title={formatMessage(strings.modalTitle)}
				className='modal-zIndex bold txt-dark lg'
			>
				<WalletTransactionModal
					data={selectedCard}
					onClose={() => handleCloseModal()}
				/>
			</Modal>
		</>
	);
};

export default WalletTransactionCard;
